<template>
    <div class="visor-pdf" v-loading="loading">
        <section class="file-preview">

			<template v-if="pages && pages.length && pages.every(p => p.data) || contentfile">
			
				<!-- TABS -->
				<div :class="['main-tabs', {'full-height': contentfile}]">
					<el-tabs v-model="activeTab" v-if="pages.length">
						<el-tab-pane 
							v-for="(page,i) in pages" 
							:key="i" 
							:label="`Página ${page.page == 'U' ? 'última' : page.page}`" 
							:name="`page_${page.page}`">
							
							<div :class="['img-holder-scroll']">
								<div
								class="img-holder"
								ref="img-holder" 
								:style="{'width': `${100}%`}">
								
									<img 
										:ref="`img_${page.page}`"
										:src="page.data"
										alt="ocr"
										@click="clickCoordinatesPage($event, page)"/>

								</div>
							</div>
						</el-tab-pane>
					</el-tabs>
				</div>

				<!-- ZOOM -->
				<div class="zoom" v-if="pages.length">
					<el-slider
						v-model="scale"
						:step="10"
						:min="0"
						:max="200"
						:marks="marks"
						:show-tooltip="false">
					</el-slider>
				</div>
			</template>
		</section>

        <template v-if="pdf && pdf.numPages">
			<canvas
			    style="display: none"
				v-for="page in pdf.numPages"
				:id="`canvas_${page}`"
				:key="page">
			</canvas>
		</template>
    </div>
</template>

<script>
    import {
		getDocumentoPDF
    } from '@/helpers/api'

    import moment from 'moment'
    
	export default {
        name: 'VisorOCR',
        props: ['id'],
        data() {
            return {
                error: null,
                loading: false,

                activeTab: 'page_1',
				scale: 100,
				marks: {
					100: {
						style: {
							color: '#1989FA'
						},
						label: this.$createElement('strong', '100%')
					}
				},

                // Gestion archivo
				pdf: null,
				file: null,
				pages: [],
				pdfjsLib: null,
				contentfile: null
            }
        },
        mounted() {
            this.getData()
            
            this.init()

            this.$emit('created')
        },
        watch: {
			scale(val) {
				this.$refs['img-holder'].forEach(elemento => elemento.style.width = `${val}%`)
			}
		},
        methods: {
            init() {
                this.pdfjsLib = window['pdfjs-dist/build/pdf']

				this.pdfjsLib.GlobalWorkerOptions.workerSrc = '//mozilla.github.io/pdf.js/build/pdf.worker.js'
            },
            async getData(e) {

                this.loading = true

                try {

                    let formData = new FormData();

                    formData.append('tipo', 'ptes');
                    formData.append('documento', this.id);

                    let resp = await getDocumentoPDF(formData)
                    
                    this.pages = await this.handlePDF(resp.data.data.file)

                } catch(e) {
                    this.error = e
                }

                this.loading = false
                
            },
            async handlePDF(pdfData) {

				console.time('handlePDF')

				let pages = []

				this.loading = true

				try {

					const loadingTask = pdfjsLib.getDocument({data: atob(pdfData)});

					this.pdf = await loadingTask.promise

					const scale = 4

					for(let i = 1; i <= this.pdf.numPages; i++) {

						let page = await this.pdf.getPage(i)
						const viewport = page.getViewport({scale})
			
						let canvas = document.getElementById(`canvas_${i}`)
						let canvasContext = canvas.getContext('2d')
						canvas.height = viewport.height
						canvas.width = viewport.width
						
						let renderTask = page.render({canvasContext, viewport})
						await renderTask.promise

						pages.push({
							page: i,
							data: canvas.toDataURL('image/jpeg'),
							cuadros: []
						})
					}

				} catch (err) {
					console.log(err)
					this.$notify.error({
						title: 'Error',
						message: 'Error al procesar el PDF'
					})
				}
		
				this.loading = false

				console.timeEnd('handlePDF')

				return pages
			}
        }
	}
</script>

<style lang="scss">
.visor-pdf {
    display: flex;
    flex-grow: 1;

    header {
        height: 56px;
        box-shadow: rgba(0, 0, 0, 0.12) 0px 0px 16px;
        z-index: 999;
        position: fixed;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 15px;
        left: 0;
        right: 0;
        width: auto;
        p {
            font-weight: 600;
            font-size: 1.1rem;
            text-transform: capitalize;
        }
    }

    section.file-preview {
        width: 100%;
        height: -webkit-fill-available;
        position: absolute;
        background-color: white;
        z-index: 9;
        padding: 0px!important;
        flex-flow: column;

        .main-tabs {
            height: calc(100% - 38px);
            &.full-height {
                height: 100%;
            }
            .el-tabs {
                height: 100%;
                display: flex;
                flex-flow: column;
                .el-tabs__content {
                    flex-grow: 1;
                    display: flex;
                    flex-flow: column;
                    .el-tab-pane {
                        flex-grow: 1;
                        display: flex;
                        flex-flow: column;
                        max-height: -webkit-fill-available;
                        .img-holder-scroll {
                            overflow: auto;
                        }
                    }
                }
            }
            .editor {
                overflow: auto;
                height: 100%;
            }
        }

        > .empty {
            text-align: center;
            margin-top: 100px;
            font-weight: 700;
            color: #afafaf;
        }

        .img-holder-scroll {
            overflow: auto;
            .img-holder {
                position: relative;
                overflow: auto;
                width: fit-content;
                transform-origin: 0% 0% 0px;
                .square-hocr {
                    top: 0;
                    position: absolute;
                    border: 1px solid #ff0606;
                }
                img {
                    width: 100%;
                }
            }
            &.cursor {
                cursor: crosshair;
            }
        }

        .zoom {
            .el-slider {
                padding: 10px 15px 20px 15px;
            }
        }
    }

    section.file-properties {
        width: 100%;
        border-left: 1px solid #dadada;
        overflow: hidden;
        padding-top: 56px;
        flex-flow: column;
        height: -webkit-fill-available;

        .file-properties-content {
            overflow: auto;
            padding: 15px;
            flex-grow: 1;
            display: flex;
            align-items: center;
            justify-content: center;

            form {
                width: 400px;
            }
        }

        .button-save {
            background-color: white;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            padding: 15px 20px;
            box-shadow: rgba(0, 0, 0, 0.12) 0px 0px 16px;
            > button {
                width: 100%;
            }
        }
    }

    @media(min-width: 768px) {
        section.file-preview,
        section.file-properties {
            position: relative;
            padding-top: 0px;
            display: flex!important;
            flex-flow: column;
        }
    }
}
</style>